import { DefaultElementStyles } from '../../Commons/styles/styles';

export const styles = {
  HeroWrapper: {
    textAlign: 'center',
  },
  HeroSectionContainer: {
    position: 'relative',
  },
  HeroSectionParagraph: {
    fontSize: '16px',
    color: '#fff',
    lineHeight: '24px',
    fontFamily: 'Poppins',
    fontWeight: '400',
  },
  HeroSectionOverline: {
    fontSize: '12px',
    color: '#fff',
    lineHeight: '18px',
    fontFamily: 'Poppins',
    fontWeight: '300',
  },
  Video: {
    objectFit: 'cover' as any,
    width: '100%',
    overflow: 'hidden',
  },
  Image: {
    objectFit: 'cover' as any,
    width: '100%',
  },
  Carousel: {
    width: '100%',
  },
  HeadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    minHeight: '100%',
  },
  Heading: {
    ...DefaultElementStyles.HeaderDefaultStyles,
    marginTop: '20px',
    marginBottom: '20px',
  },
  HeroSectionSubHeading: {
    ...DefaultElementStyles.ParagraphDefaultStyles,
    marginTop: '20px',
    marginBottom: '20px',
  },
  btnContainer: {
    margin: '20px 0',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '20px',
    width: '100%',
    alignItems: 'center',
    '@media (max-width: 780px)': {
      justifyContent: 'center',
      flexDirection: 'column',
      marginBottom: '20px',
    },
  },
  btnContainer_Mobile: {
    margin: '20px 0',
    marginBottom: '20px',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '20px',
    // flexDirection: 'column',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
};
